import { jsx as o } from "react/jsx-runtime";
import "react";
import t from "./LoadingCircle.styled.js";
const a = ({
  color: r = "graphic/contrast-highest",
  ...i
}) => /* @__PURE__ */ o(t, { dynamicColor: r, ...i });
a.displayName = "LoadingCircle";
export {
  a as default
};
//# sourceMappingURL=LoadingCircle.js.map
